export default __webpack_public_path__ + "tab2_mobile3fc1c4.mp4";